<template>
    <div class="coupon-list-main">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <coupon v-for="coupon in couponList" :key="coupon.id"/>
        </van-list>
    </div>
</template>

<script>
import {List} from "vant";
import Coupon from "@/components/Coupon.vue";
// import request from "@/utils/request.js";
export default {
    name: 'CouponList',
    components: {
        [Coupon.name]: Coupon,
        [List.name]: List
    },
    data() {
        return {
            finished: true,
            loading: false,
            couponList: [{}]
        };
    },
    methods: {
        onLoad() {

        }
    }
}
</script>

<style lang="less">

</style>>
